import { getPaginationBreakdown } from '#choo-app/lib/editor/plugins/inlinePageBreaks'
import {
  getTitlePageViewState,
  hasTitlePage,
  setTitlePageView,
} from '#choo-app/lib/editor/plugins/titlePageView'
import { getRootStore } from '#state/models/getRootStore'
import { getTitlePageCount } from '#util/prosemirrorHelpers'
import { scrollToBlock } from '#util/scrolling'

import { BaseModel } from './BaseModel'

export const TitlePage = BaseModel.named('TitlePage')
  .props({})
  .views((self) => ({
    get titlePageCount(): number | null {
      const editorState =
        getRootStore(self).currentScript?.pmEditor?.editorState
      if (!editorState) return null
      return getTitlePageCount(editorState)
    },
    get hasTitlePages(): boolean {
      const editorState =
        getRootStore(self).currentScript?.pmEditor?.editorState
      return editorState ? hasTitlePage(editorState) : false
    },
    get titlePageVisible(): boolean {
      const editorState =
        getRootStore(self).currentScript?.pmEditor?.editorState
      if (!editorState) return false
      const pluginState = getTitlePageViewState(editorState)
      return pluginState?.showTitlePageView ?? false
    },
    get currentTitlePageNumber(): number | null {
      if (!this.titlePageVisible) return null

      const editorState =
        getRootStore(self).currentScript?.pmEditor?.editorState
      if (!editorState) return null

      const breakdown = getPaginationBreakdown(editorState)
      if (!breakdown) return null

      const cursorPos = editorState.selection.from
      const titlePageIndex = breakdown.titlePageIndexAtPosition(cursorPos)

      if (titlePageIndex >= 0) {
        return titlePageIndex + 1
      }

      return null
    },
  }))
  .actions((self) => ({
    setTitlePageVisible(value: boolean) {
      getRootStore(self).currentScript?.pmEditor?.invoke(
        setTitlePageView(value),
      )
    },
    handleTitlePageClick(pageNumber: number) {
      if (
        getRootStore(self).currentScript?.pmEditor?.invoke(
          setTitlePageView(true),
        )
      ) {
        scrollToBlock(`title-page-${pageNumber}`, { flash: false })
      }
    },
  }))

export type ITitlePage = typeof TitlePage.Type
